import {
	getActiveAlarm,
	getActiveAlarmFlexidas,
	getActiveOranAlarm,
	getHistoryAlarmFlexidas,
} from '@api/alarmHistory';

import { IActiveAlarmOran } from '@interfaces/alarms/alarm';

import { EVendorsValues } from '@enums/common';

import { useQueryActiveOranAlarm } from './useQueryActiveOranAlarm';

const getAlarmsFiltersRequest = (vendor: string, isHistory?: boolean) => {
	switch (vendor) {
		case EVendorsValues.flexidas:
			return isHistory ? getHistoryAlarmFlexidas : getActiveAlarmFlexidas;
		case EVendorsValues.limenet:
			return getActiveAlarm;
		case EVendorsValues.oran:
		case EVendorsValues.benetel:
			return getActiveOranAlarm;
		default:
			return getActiveOranAlarm;
	}
};

interface IUseAlarmDetailsReturned {
	alarm: IActiveAlarmOran | null;
	isLoadingAlarm: boolean;
}

export const useAlarmDetails = (
	vendor: string,
	id: string,
	isHistory?: boolean,
): IUseAlarmDetailsReturned => {
	const queryFn = getAlarmsFiltersRequest(vendor, isHistory);

	const { alarm, isLoadingAlarm } = useQueryActiveOranAlarm(id, queryFn, vendor);

	return {
		alarm,
		isLoadingAlarm,
	};
};
